export default "__VITE_ASSET___5jRoBjH__"